import React, { useState, useEffect } from "react";
import axios from "axios";
import "./NewService.css";
import AlertModal from "./AlertModal";
import { Alert } from "react-bootstrap";
import API_URL from "../config";
import api from "./Api";
export default function UpdateService({ k, onClose }) {
  const [clientName, setClientName] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [wahName, setwahName] = useState("");

  const [clientCode, setClientCode] = useState("");
  const [prixService, setPrixService] = useState(0);
  const [prixService2, setPrixService2] = useState(0);
  const [avecMeche, setAvecMeche] = useState(false);
  const [coutMeche, setCoutMeche] = useState(0);
  const [avecWash, setAvecWash] = useState(false);
  const [prixWash, setPrixWash] = useState(0);
  const [wahCode, setwahCode] = useState("");
  const [tresseuse1, setTresseuse1] = useState("");
  const [tresseuse2, setTresseuse2] = useState("");
  const [tresseuse3, setTresseuse3] = useState("");
  const [codtres1, setCodtres1] = useState("NON");
  const [codtres2, setCodtres2] = useState("NON");
  const [codtres3, setCodtres3] = useState("NON");
  const [nbTresseuses, setNbTresseuses] = useState("UN");
  const [shop, setShop] = useState("SH1---Shop 1");
  const [total, setTotal] = useState(0);
  const [ldate, setLdate] = useState("");
  const [serviceSearch, setServiceSearch] = useState([]);
  const [washSearch, setWashSearch] = useState([]);
  const [tres1Search, setTres1Search] = useState([]);
  const [tres2Search, setTres2Search] = useState([]);
  const [tres3Search, setTres3Search] = useState([]);
  const [nbreserv, setNbreserv] = useState(""); // ID réel
  const [idservice, setIdService] = useState(""); // ID réel
  const [codservice, setCodService] = useState(""); // ID réel
  const [nbserv, setnbserv] = useState(1);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const showModalAlert = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
  };
  const formatDollar = (amount) => {
    if (amount == null) return "$0.00"; // gestion des valeurs nulles
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };
  const useDebouncedSearch = (searchText, setResults) => {
    useEffect(() => {
      const fetchData = async () => {
        if ((searchText + "").trim() === "") {
          setResults([]);
          return;
        }

        try {
          const payload = {
            idtres: searchText,
            date: ldate,
          };
          const res = await axios.post(
            `${API_URL}/search-tresseuses3/`,
            payload,
          );

          setResults(res.data.data);
        } catch (error) {
          console.error("Erreur lors du chargement :", error);
        }
      };

      const timer = setTimeout(fetchData, 300); // debounce
      return () => clearTimeout(timer);
    }, [searchText, setResults]);
  };

  // --- Appliquer le hook pour chaque champ ---
  useDebouncedSearch(wahName, setWashSearch);
  useDebouncedSearch(tresseuse1, setTres1Search);
  useDebouncedSearch(tresseuse2, setTres2Search);
  useDebouncedSearch(tresseuse3, setTres3Search);

  // fonction générique
  const handleChangew = (e) => {
    const value = e.target.value.toUpperCase();
    setwahName(value);

    // retrouver l'objet correspondant
    const selected = washSearch.find(
      (tres) => `${tres.nomtres} (${tres.numcode})`.toUpperCase() === value,
    );

    if (selected) {
      setwahCode(selected.codtres);
    }
  };
  const handleChange = (e, searchList, setTresseuse, setCodtres) => {
    const value = e.target.value.toUpperCase();
    setTresseuse(value);

    const selected = searchList.find(
      (tres) => `${tres.nomtres} (${tres.numcode})`.toUpperCase() === value,
    );

    if (selected) {
      setCodtres(selected.codtres);
    }
  };
  // Convertir k en nom client
  useEffect(() => {
    if (k) {
      const parts = k.split("@@");
      setClientName(parts[0] + "---" + parts[1]);
      setLdate(parts[4]);
      setNbreserv(parts[2]);
      setClientCode(parts[0]);
    }
  }, [k]);
  const handleSelect = (e) => {
    const selected = serviceSearch.find((s) =>
      e.target.value.startsWith(s.nomtypt),
    );
    if (selected) {
      setPrixService(selected.prix);
      setServiceName(selected.nomtypt); // optionnel si tu veux garder juste le nom
      setIdService(selected.codtypt);
    }
  };

  useEffect(() => {
    if (nbreserv && clientCode) {
      ChargeInfoClientService(nbreserv, clientCode, ldate, {
        setServiceName,
        setPrixService,
        setCoutMeche,
        setPrixWash,
        setShop,
        setNbreserv,
        setNbTresseuses,
        setTresseuse1,
        setTresseuse2,
        setTresseuse3,
        setwahName,
        setCodtres1,
        setCodtres2,
        setCodtres3,
        setwahCode,
        setIdService,
        setCodService,
      });
    }
  }, [nbreserv, clientCode, ldate]);

  const ChargeInfoClientService = async (codserv, codclt, ldate, setters) => {
    try {
      const res = await axios.post(`${API_URL}/info-client-service/`, {
        mat: codserv,
        lclts: codclt,
        ldate: ldate,
      });

      const { service, tresseuses, nbre_service_jour } = res.data;

      setters.setCodService(service.codeserv);
      setters.setIdService(service.code);
      setters.setServiceName(service.name);
      //setters.setPrixService(service.prix_service);
      setters.setCoutMeche(service.prix_meche);
      setters.setPrixWash(service.prix_wash);
      const prixWash2 = Number(service.prix_wash) || 0;
      const prixmeche = Number(service.prix_meche) || 0;
      const prixservice = Number(service.prix_service) || 0;
      const prixservice2 = prixservice - prixmeche - prixWash2;
      setters.setPrixService(prixservice2);
      setters.setShop(service.shop);
      setters.setNbreserv(nbre_service_jour);
      // Gestion tresseuses
      if (tresseuses.length === 1) {
        setters.setNbTresseuses("UN");
        setters.setTresseuse1(`${tresseuses[0].name} (${tresseuses[0].code})`);
        setters.setCodtres1(`${tresseuses[0].codeid}`);
      }

      if (tresseuses.length === 2) {
        if (Number(prixWash2) > 0) {
          setters.setNbTresseuses("UN");
          setters.setTresseuse1(
            `${tresseuses[0].name} (${tresseuses[0].code})`,
          );
          setters.setCodtres1(`${tresseuses[0].codeid}`);
          setters.setwahName(`${tresseuses[1].name} (${tresseuses[1].code})`);
          setters.setwahCode(`${tresseuses[1].codeid}`);
        } else {
          setters.setNbTresseuses("DEUX");
          setters.setTresseuse1(
            `${tresseuses[0].name} (${tresseuses[0].code})`,
          );
          setters.setCodtres1(`${tresseuses[0].codeid}`);
          setters.setTresseuse2(
            `${tresseuses[1].name} (${tresseuses[1].code})`,
          );
          setters.setCodtres2(`${tresseuses[1].codeid}`);
        }
      }

      if (tresseuses.length === 3) {
        if (Number(prixWash2) > 0) {
          setters.setNbTresseuses("DEUX");
          setters.setTresseuse1(
            `${tresseuses[0].name} (${tresseuses[0].code})`,
          );
          setters.setCodtres1(`${tresseuses[0].codeid}`);
          setters.setTresseuse2(
            `${tresseuses[1].name} (${tresseuses[1].code})`,
          );
          setters.setCodtres2(`${tresseuses[1].codeid}`);
          setters.setwahName(`${tresseuses[2].name} (${tresseuses[2].code})`);
          setters.setwahCode(`${tresseuses[2].codeid}`);
        } else {
          setters.setNbTresseuses("TROIS");
          setters.setTresseuse1(
            `${tresseuses[0].name} (${tresseuses[0].code})`,
          );
          setters.setCodtres1(`${tresseuses[0].codeid}`);
          setters.setTresseuse2(
            `${tresseuses[1].name} (${tresseuses[1].code})`,
          );
          setters.setCodtres2(`${tresseuses[1].codeid}`);
          setters.setTresseuse3(
            `${tresseuses[2].name} (${tresseuses[2].code})`,
          );
          setters.setCodtres3(`${tresseuses[2].codeid}`);
        }
      }
      if (tresseuses.length === 4) {
        setters.setNbTresseuses("TROIS");
        setters.setTresseuse1(`${tresseuses[0].name} (${tresseuses[0].code})`);
        setters.setCodtres1(`${tresseuses[0].codeid}`);
        setters.setTresseuse2(`${tresseuses[1].name} (${tresseuses[1].code})`);
        setters.setCodtres2(`${tresseuses[1].codeid}`);
        setters.setTresseuse3(`${tresseuses[2].name} (${tresseuses[2].code})`);
        setters.setCodtres3(`${tresseuses[2].codeid}`);
        setters.setwahName(`${tresseuses[3].name} (${tresseuses[3].code})`);
        setters.setwahCode(`${tresseuses[3].codeid}`);
      }
    } catch (error) {
      console.error("Erreur chargement service :", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (serviceName.trim() === "") {
        setServiceSearch([]);
        return;
      }

      try {
        const res = await axios.get(
          `${API_URL}/search_type_by_name/${serviceName}/`,
        );
        setServiceSearch(res.data);
      } catch (error) {
        console.error("Erreur lors du chargement :", error);
      }
    };

    // petit délai (debounce) pour éviter trop de requêtes pendant la saisie
    const timer = setTimeout(fetchData, 300);
    return () => clearTimeout(timer);
  }, [serviceName]);

  useEffect(() => {
    const sum = Number(prixService) + Number(coutMeche) + Number(prixWash);
    setPrixService2(Number(prixService));
    setTotal(sum);
  }, [prixService, coutMeche, prixWash]);

  const saveService = async () => {
    if (idservice === "") {
      showModalAlert("Please choose a hairstyle ❌");
      return;
    }
    if (Number(prixWash) > 0) {
      if (wahCode === "") {
        showModalAlert("Please choose Washer ❌");
        return;
      }
    }
    if (codtres1 === "NON") {
      showModalAlert("Please choose Braiders ❌");
      return;
    }

    try {
      const payload = {
        client: clientName,
        service: idservice,
        prixService,
        prixService2,
        avecMeche,
        coutMeche,
        avecWash,
        prixWash,
        tresseuse1: codtres1,
        tresseuse2: codtres2,
        tresseuse3: codtres3,
        nbTresseuses,
        shop,
        ldate,
        wahName: wahCode,
        nbserv,
        codservice,
      };
      const response = api
        .post("update_service/", payload)
        .then((res) => console.log(res.data))
        .catch((err) => console.error(err));
      //  const response = await axios.post(`${API_URL}/update_service/`, payload);
      setClientName("");
      setServiceName("");
      setwahName("");
      setwahCode("");
      setPrixService(0);
      setPrixService2(0);
      setAvecMeche(false);
      setCoutMeche(0);
      setAvecWash(false);
      setPrixWash(0);
      setTresseuse1("");
      setTresseuse2("");
      setTresseuse3("");
      setCodtres1("NON");
      setCodtres2("NON");
      setCodtres3("NON");
      setNbTresseuses("un");
      setShop("SH1---Shop 1");
      setnbserv(1);
      setTotal(0);
      showModalAlert("Save succesfully ✔");

      onClose();
      console.log(response.data);
    } catch (error) {
      console.error(error);
      alert("Erreur lors de l'enregistrement !");
    }
  };

  return (
    <div className="container-box">
      <div className="card9" style={{ padding: "20px" }}>
        <h3>UPDATE OF A CLIENT'S SERVICE</h3>

        <div className="row3">
          <div className="col-lg-3 col-md-3">
            <label className="field-label">Nom du client</label>
            <input value={clientName} disabled className="input" />
          </div>
          <div className="col-lg-5 col-md-5">
            <label className="field-label">Service / Hairstyle Name</label>
            <input
              type="text"
              placeholder="Enter the name of the hairstyle"
              value={serviceName}
              onChange={(e) => setServiceName(e.target.value)}
              onSelect={handleSelect}
              className="input"
              list="groupDatalist"
            />

            <datalist id="groupDatalist">
              {(Array.isArray(serviceSearch) ? serviceSearch : []).map(
                (tres) => (
                  <option
                    key={tres.idtypt}
                    value={`${tres.nomtypt} - (${formatDollar(tres.prix)})`}
                  />
                ),
              )}
            </datalist>
          </div>

          <div className="col-lg-1 col-md-1">
            <label className="field-label">Prix Serv</label>
            <input
              type="number"
              placeholder="0"
              value={prixService}
              onChange={(e) => setPrixService(e.target.value)}
              className="input"
            />
          </div>

          <div className="col-lg-1 col-md-1">
            <label className="field-label">Prix Serv</label>
            <input
              type="text"
              placeholder="0"
              value={formatDollar(prixService2)}
              disabled
              className="input"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">N Shop</label>
            <select
              value={shop}
              onChange={(e) => setShop(e.target.value)}
              className="input"
            >
              <option>SH1---Shop 1</option>
              <option>SH2---Shop 2</option>
              <option>SH3---Shop 3</option>
              <option>SH4---Shop 4</option>
            </select>
          </div>
        </div>

        <div className="row3">
          <div className="col-lg-1 col-md-1">
            <label className="field-label">N. Services</label>
            <select
              value={nbserv}
              onChange={(e) => setnbserv(e.target.value)}
              className="input"
            >
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
            </select>
          </div>
          <div className="col-lg-2 col-md-2">
            <div className="meche-column">
              <label className="meche-check">
                <input
                  type="checkbox"
                  checked={avecMeche}
                  onChange={() => setAvecMeche(!avecMeche)}
                />
                Avec mèches
              </label>

              <input
                type="number"
                value={coutMeche}
                onChange={(e) => setCoutMeche(e.target.value)}
                className="input"
                placeholder="Coût mèche"
              />
            </div>{" "}
          </div>

          <div className="col-lg-1 col-md-1">
            <div className="meche-column">
              <label className="meche-check">
                <input
                  type="checkbox"
                  checked={avecWash}
                  onChange={() => setAvecWash(!avecWash)}
                />
                Wash
              </label>

              <input
                type="number"
                value={prixWash}
                onChange={(e) => setPrixWash(e.target.value)}
                className="input"
                placeholder="Coût lavage"
              />
            </div>{" "}
          </div>

          <div className="col-lg-4 col-md-4">
            <label className="field-label">Choose washer</label>

            <input
              placeholder="Choose the braider"
              value={wahName}
              onChange={(e) =>
                handleChange(e, washSearch, setwahName, setwahCode)
              }
              className="input"
              disabled={Number(prixWash) === 0}
              list="grouptrewash"
            />

            <datalist id="grouptrewash">
              {(Array.isArray(washSearch) ? washSearch : []).map((tres) => (
                <option
                  key={tres.codtres}
                  value={`${tres.nomtres} (${tres.numcode})`}
                  data-codtres={tres.codtres}
                />
              ))}
            </datalist>
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Total cost</label>
            <input
              type="text"
              placeholder="0"
              disabled
              value={formatDollar(total)}
              onChange={(e) => setPrixService(e.target.value)}
              className="input"
            />
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Today's date</label>
            <input
              type="date"
              value={ldate}
              onChange={(e) => setLdate(e.target.value)}
              className="input"
            />
          </div>
        </div>

        <h4>Braiders</h4>
        <div className="row">
          <label>
            <input
              type="radio"
              value="UN"
              checked={nbTresseuses === "UN"}
              onChange={() => setNbTresseuses("UN")}
            />{" "}
            Select only one braider
          </label>
          <label>
            <input
              type="radio"
              value="DEUX"
              checked={nbTresseuses === "DEUX"}
              onChange={() => setNbTresseuses("DEUX")}
            />{" "}
            Choose two braiders
          </label>
          <label>
            <input
              type="radio"
              value="TROIS"
              checked={nbTresseuses === "TROIS"}
              onChange={() => setNbTresseuses("TROIS")}
            />{" "}
            Choose three braiders
          </label>
        </div>
        <div className="row">
          <input
            placeholder="Choose the first braider"
            value={tresseuse1}
            onChange={(e) =>
              handleChange(e, tres1Search, setTresseuse1, setCodtres1)
            }
            className="input"
            list="grouptres1"
          />

          <datalist id="grouptres1">
            {(Array.isArray(tres1Search) ? tres1Search : []).map((tres) => (
              <option
                key={tres.codtres}
                value={`${tres.nomtres} (${tres.numcode})`}
                data-codtres={tres.codtres}
              />
            ))}
          </datalist>
        </div>
        {nbTresseuses !== "UN" && (
          <div className="row">
            <input
              placeholder="Choose the second braider "
              value={tresseuse2}
              onChange={(e) =>
                handleChange(e, tres2Search, setTresseuse2, setCodtres2)
              }
              className="input"
              list="grouptres2"
            />

            <datalist id="grouptres2">
              {(Array.isArray(tres2Search) ? tres2Search : []).map((tres) => (
                <option
                  key={tres.codtres}
                  value={`${tres.nomtres} (${tres.numcode})`}
                  data-codtres={tres.codtres}
                />
              ))}
            </datalist>
          </div>
        )}

        {nbTresseuses === "TROIS" && (
          <div className="row">
            <input
              placeholder="Choose the third braider"
              value={tresseuse3}
              onChange={(e) =>
                handleChange(e, tres3Search, setTresseuse3, setCodtres3)
              }
              className="input"
              list="grouptres3"
            />

            <datalist id="grouptres3">
              {(Array.isArray(tres3Search) ? tres3Search : []).map((tres) => (
                <option
                  key={tres.codtres}
                  value={`${tres.nomtres} (${tres.numcode})`}
                  data-codtres={tres.codtres}
                />
              ))}
            </datalist>
          </div>
        )}

        <div className="row">
          <button className="btn" onClick={saveService}>
            Save
          </button>
          <button
            className="btn red"
            onClick={() => {
              if (onClose) onClose();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
      <AlertModal
        show={showAlert}
        message={alertMessage}
        onClose={() => setShowAlert(false)}
      />
    </div>
  );
}
